import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { countries, Country, isSomething } from '@tokeet-frontend/tv3-platform'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable()
export class PhoneService {
  constructor(private http: HttpClient) {}

  countries(): Observable<Country[]> {
    return this.http
      .get<{
        http_code: string
        response: {
          data: {
            countries: string[]
          }
          status: string
        }
      }>(`@api/v1/message/whatsapp-phone-countries`)
      .pipe(
        map((response) => {
          const countryCodes = response?.response?.data?.countries || []
          return countries.filter((c) => countryCodes.includes(c.id))
        })
      )
  }

  buyPhone(data: { countryCode: string }) {
    const url = `@api/v1/message/buy-phone`
    return this.http
      .post<{
        http_code: string
        response:
          | {
              error: {
                message: string
              }
              status: 'failed'
            }
          | {
              data: {
                phoneNumber: string
                clientSecret?: string
                account: number
              }
              status: 'success'
            }
      }>(url, data)
      .pipe(
        map((response) => {
          if (response.response.status === 'failed') {
            return { success: false, message: response?.response?.error?.message }
          } else if (response.response.status === 'success' && isSomething(response.response.data?.clientSecret)) {
            return { success: false, clientSecret: response.response.data?.clientSecret }
          }
          return { success: true }
        })
      )
  }
}
